import csrfAxios from "@shared/csrfAxios";

const route = "/support/super_users";

const jsonAcceptHeaders = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

const SuperUserRequests = {
  create: async (params) => {
    await csrfAxios.post(route, { super_user: params });
  },
  csvExport: () => window.open(`${route}.csv`),
  index: async (page) => {
    const response = await csrfAxios.get(
      `${route}?page=${page}`,
      jsonAcceptHeaders
    );

    return response.data;
  },
  search: async (searchTerm = "", roleFilter = "", page = 1) => {
    const response = await csrfAxios.get(
      `${route}?q=${searchTerm}&role=${roleFilter}&page=${page}`,
      jsonAcceptHeaders
    );

    return response.data;
  },
  update: async (id, params) => {
    await csrfAxios.put(
      `${route}/${id}`,
      { super_user: params }
    );
  },
  destroy: async (id) => {
    await csrfAxios.delete(`${route}/${id}`)
  }

};

export default SuperUserRequests;
